<!-- Super header - visible only on student routes -->
<div class="w-full bg-gray-100 py-2 text-center text-sm">
  <span class="block md:inline">Recon-Media: Empowering Service Members, Veterans, and Their Families</span>

  <span class="block md:ml-1 md:inline">
    <a
      class="mx-1 cursor-pointer text-blue-600 hover:underline"
      (click)="view('https://mymilitarybenefits.com')"
    >
      Benefits
    </a>
    |
    <a
      class="mx-1 cursor-pointer text-blue-600 hover:underline"
      (click)="view('https://collegerecon.com')"
    >
      Education
    </a>
    |
    <a
      class="mx-1 cursor-pointer text-blue-600 hover:underline"
      (click)="view('https://careerrecon.com')"
    >
      Careers
    </a>
  </span>
</div>

<!-- Header Component -->
<header></header>
<div class="flex flex-col bg-[#F8F9FA] lg:flex-row">
  <!-- sidenav -->
  <aside
    class="relative z-[99999] md:top-0 lg:sticky"
    *ngIf="pathname !== API_CONSTANT.SUCCESS.replace('/', '')"
  >
    <p-sidebar
      #sidebarRef
      [(visible)]="sidebarVisible"
      styleClass="w-auto bg-transparent shadow-none"
    >
      <ng-template pTemplate="headless">
        <span
          (click)="closeCallback()"
          *ngIf="sidebarVisible"
          class="pi pi-times absolute right-4 top-4 h-[1rem] w-[1rem] cursor-pointer text-white"
        ></span>
        <sidenav></sidenav>
      </ng-template>
    </p-sidebar>
  </aside>

  <div
    class="sticky top-0 flex justify-start rounded border-b border-gray-300 bg-transparent p-4"
    *ngIf="!sidebarVisible"
  >
    <span
      (click)="onMenuToggle()"
      class="h-[2.5rem] w-[2.5rem] cursor-pointer rounded bg-white text-center leading-loose drop-shadow-md"
    >
      <i class="pi pi-list" style="font-size: 1.5rem; line-height: 2.5rem"></i>
    </span>
    <app-typography
      [component]="'h5'"
      [variant]="'header'"
      class="grow text-center"
    ></app-typography>
  </div>
  <!-- main content-->
  <main class="admin-container w-full p-4" style="scrollbar-width: none">
    <img
      class="absolute bottom-0 right-0 z-[99999] mb-4 cursor-pointer md:hidden"
      src="../../../../assets/img/newsletter_logo.svg"
      alt=""
      (click)="newsletterModal = true"
    />
    <div *ngIf="newsletterModal">
      <app-modal
        [open]="newsletterModal"
        title="Subscribe To Our Newsletters"
        [variant]="'primary'"
        (onClose)="newsletterModal = false"
      >
        @for (newsletter of newsletters; track $index) {
          <div class="my-2 grid grid-cols-2 justify-between gap-4">
            <div *ngIf="newsletter?.type === 'image'">
              <img
                [src]="newsletter?.image"
                [alt]="newsletter?.alt"
                class="h-10"
              />
            </div>
            <div *ngIf="newsletter?.type === 'link'">
              <app-typography [component]="'anchor'" [variant]="'mobileHeader'">
                {{ newsletter?.text }}
              </app-typography>
            </div>
            <app-button
              class="flex justify-end"
              [label]="'Subscribe'"
              (sendClick)="view(newsletter?.url)"
              *ngIf="newsletter?.buttonName"
            ></app-button>
          </div>
          <hr />
        }
      </app-modal>
    </div>

    <router-outlet></router-outlet>
  </main>
</div>

<!-- <footer></footer> -->
